import React from 'react'
import { ServiceOrderDetail } from '@/presentation/pages/ServiceOrderDetail'
import { makeGetServiceOrderDetail } from '@/main/factories/usecases'

export const makeServiceOrderDetailFactory = (): JSX.Element => {
  return <ServiceOrderDetail getServiceOrderDetail={makeGetServiceOrderDetail()}/>
}
